import { useState, Fragment, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Fab from "@mui/material/Fab";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Sidebar from "../../components/Sidebar";
import Box from "@mui/material/Box";
import { API_URL, MAIN_TITLE, alertMessage } from "../../actions/auth";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import moment from "moment";
import { themeStyle } from "../../components/Components";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import TextField from "@mui/material/TextField";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import LocalDiningIcon from "@mui/icons-material/LocalDining";
import Drawer from "@mui/material/Drawer";
import GavelIcon from "@mui/icons-material/Gavel";
import BallotIcon from "@mui/icons-material/Ballot";
import ComputerIcon from "@mui/icons-material/Computer";
import HistoryIcon from "@mui/icons-material/History";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import PublicIcon from "@mui/icons-material/Public";
import CalculateIcon from "@mui/icons-material/Calculate";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import Checkbox from "@mui/material/Checkbox";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MenuItem from "@mui/material/MenuItem";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Select from "@mui/material/Select";
import IconButton from "@mui/material/IconButton";
import SchoolIcon from "@mui/icons-material/School";
import Typography from "@mui/material/Typography";
import PublishIcon from "@mui/icons-material/Publish";
import { CloudUpload, Description, Close } from "@mui/icons-material";
import { styled } from "@mui/material";

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

const Dropzone = styled("div")(({ theme }) => ({
  border: `2px dashed ` + themeStyle.primaryColor,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(6),
  textAlign: "center",
  cursor: "pointer",
}));

const FileUploadCard = () => {
  return (
    <Box sx={{ maxWidth: 400, mx: "auto", marginBottom: "50px" }} elevation={1}>
      <Dropzone>
        <CloudUpload
          fontSize="large"
          sx={{ color: themeStyle.primaryColor, mb: 1, fontSize: "50px" }}
        />
        <Typography variant="body1">Click here to upload your file</Typography>
        <Typography variant="caption" color="text.secondary">
          with .xlsx file extension (Max 25MB)
        </Typography>
      </Dropzone>
    </Box>
  );
};

function ClassesOnboarding() {
  const dispatch = useDispatch();
  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }
  const state = useSelector((state) => state);
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);

  const params = new URLSearchParams(window.location.search);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [open5, setOpen5] = useState(false);
  const [open6, setOpen6] = useState(false);
  const [promoteSubmitAnswer, setPromoteSubmitAnswer] = useState("NO");
  const [selectedFile, setSelectedFile] = useState("");

  const [classList, setClassList] = useState([]);
  const [classListOld, setClassListOld] = useState([]);
  const [feesStructure, setFeesStructure] = useState({});
  const [isUploading, setIsUploading] = useState("");

  const [classs, setClass] = useState("");
  const [division, setDivision] = useState("");
  const [semester, setSemester] = useState("");

  const [classs2, setClass2] = useState("");
  const [division2, setDivision2] = useState("");
  const [info, setInfo] = useState({});
  const [isReady, setIsReady] = useState(false);
  const [random, setRandom] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedClassesPage, setSelectedClassesPage] = useState("CLASSES");
  const [selectedClassesPageClass, setSelectedClassesPageClass] = useState("");
  const [selectedClassesPageClassIndex, setSelectedClassesPageClassIndex] =
    useState(9999);

  const [selectedClassesPageDivision, setSelectedClassesPageDivision] =
    useState("");

  const [
    selectedClassesPageDivisionIndex,
    setSelectedClassesPageDivisionIndex,
  ] = useState(9999);

  const [selectedClassesPageSemester, setSelectedClassesPageSemester] =
    useState("");
  const [
    selectedClassesPageSemesterIndex,
    setSelectedClassesPageSemesterIndex,
  ] = useState(9999);

  const [teacherList, setTeacherList] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState([]);
  const [finalized, setFinalized] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [tempText, setTempText] = useState("");
  const [toggleDrawer, setToggleDrawer] = useState(false);

  const [selectedClassesSubjectIndex, setSelectedClassesSubjectIndex] =
    useState(9999);

  useEffect(() => {
    if (state.auth.isLoading) {
      dispatch({ type: "ENTRY_PAGE", payload: window.location.pathname });
      navigate("/", { replace: true });
    } else {
      getData();
    }
  }, []);

  function handleSemesterChange(e) {
    setSemester(e.target.value);
  }

  function handleClassChange(e) {
    setClass2(e.target.value);
    setDivision2(Object.keys(classList[e.target.value])[0]);
    setSemester(
      Object.keys(
        classList[e.target.value][Object.keys(classList[e.target.value])[0]]
      )[0]
    );
  }

  function handleDivisionChange(e) {
    setDivision2(e.target.value);
    setSemester(Object.keys(classList[classs][division])[0]);
  }

  function onFileUpload() {
    setIsUploading(true);
    const formData = new FormData();
    formData.append("file", selectedFile, selectedFile.name);

    const config = {
      headers: {
        Authorization: state.auth.token,
      },
    };

    formData.append("user_id", state.auth.user.user_id);
    formData.append("filename", selectedFile.name);
    formData.append("institution_id", state.auth.user.institution_id);
    formData.append("class_id", classs2);
    formData.append("division", division2);
    formData.append("class_type", state.auth.classType);
    formData.append("semester", semester);

    axios
      .post(API_URL + "/update_subjects_xl", formData, config)
      .then(() => {
        setIsUploading(false);
        createAlert("SUCCESS", "Success.", "Document uploaded.");
        getData();
      })
      .catch((err) => {
        setIsUploading(false);
        createAlert("ERROR", "Error", "An error occured.");
      });

    setOpen3(false);
    document.getElementById("contained-button-file").value = "";
  }

  function onFileChange(event) {
    console.log(event.target.files[0]);
    setSelectedFile(event.target.files[0]);
    setOpen3(true);
  }

  function fileData() {
    if (selectedFile) {
      return (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <h2>File Details:</h2>

            <IconButton size="small">
              <CloseIcon
                onClick={() => setOpen(false)}
                style={{ color: themeStyle.primaryColor }}
              />
            </IconButton>
          </div>
          <p>File Name: {selectedFile.name}</p>
          <p>File Type: {selectedFile.type}</p>

          <br></br>
          <br></br>
          {selectedFile.size > 25 * 1024 * 1024 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  createAlert(
                    "ERROR",
                    "File too big.",
                    "File size should be less than 25 MB."
                  );
                  setOpen(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD DOCUMENTS
              </Button>
            </div>
          ) : selectedFile.name.length >= 50 ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                onClick={() => {
                  createAlert(
                    "ERROR",
                    "File name to obig.",
                    "File size should be less than 50 characters."
                  );
                  setOpen(false);
                }}
                variant="contained"
                style={{ backgroundColor: "#ddd" }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD DOCUMENTS
              </Button>
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                onClick={() => onFileUpload()}
                style={{ backgroundColor: themeStyle.primaryColor }}
              >
                <PublishIcon />
                &nbsp;&nbsp; UPLOAD DOCUMENTS
              </Button>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div>
          <h4>Choose before Pressing the Upload button</h4>
        </div>
      );
    }
  }

  function saveClassName(oldClassName, classIndex) {
    var className = tempText;
    var tempClassList = classList;
    var tempClassValue = tempClassList[oldClassName];

    if (oldClassName.includes("#edited#")) {
      var oldClassNameTemp = oldClassName.split("#edited#")[1];
      if (oldClassNameTemp == className) {
        tempClassList[className] = tempClassValue;
      } else {
        tempClassList[className + "#edited#" + oldClassNameTemp] =
          tempClassValue;
      }
    } else {
      tempClassList[
        className + "#edited#" + Object.keys(classList)[classIndex]
      ] = tempClassValue;
    }

    delete tempClassList[oldClassName];
    setSelectedClassesPageClassIndex(Object.keys(tempClassList).length - 1);
    setClassList(tempClassList);
    setRandom(makeid(5));
  }

  function saveDivisionName(oldDivisionName, divisionIndex) {
    var divisionName = tempText;
    var tempClassList = classList;
    var tempDivisionValue =
      tempClassList[selectedClassesPageClass][oldDivisionName];

    if (oldDivisionName.includes("#edited#")) {
      var oldDivisionNameTemp = oldDivisionName.split("#edited#")[1];
      if (oldDivisionNameTemp == divisionName) {
        tempClassList[selectedClassesPageClass][divisionName] =
          tempDivisionValue;
      } else {
        tempClassList[selectedClassesPageClass][
          divisionName + "#edited#" + oldDivisionNameTemp
        ] = tempDivisionValue;
      }
    } else {
      tempClassList[selectedClassesPageClass][
        divisionName +
          "#edited#" +
          Object.keys(classList[selectedClassesPageClass])[divisionIndex]
      ] = tempDivisionValue;
    }

    delete tempClassList[selectedClassesPageClass][oldDivisionName];
    setSelectedClassesPageDivisionIndex(
      Object.keys(tempClassList[selectedClassesPageClass]).length - 1
    );
    setClassList(tempClassList);
    setRandom(makeid(5));
  }

  function saveSemesterName(oldSemesterName, semesterIndex) {
    var semesterName = tempText;
    var tempClassList = classList;
    var tempSemesterValue =
      tempClassList[selectedClassesPageClass][selectedClassesPageDivision][
        Object.keys(
          classList[selectedClassesPageClass][selectedClassesPageDivision]
        )[semesterIndex]
      ];

    if (
      Object.keys(
        classList[selectedClassesPageClass][selectedClassesPageDivision]
      )[semesterIndex].includes("#edited#")
    ) {
      var oldSemesterNameTemp = oldSemesterName.split("#edited#")[1];
      if (oldSemesterNameTemp == semesterName) {
        tempClassList[selectedClassesPageClass][selectedClassesPageDivision][
          semesterName
        ] = tempSemesterValue;
      } else {
        tempClassList[selectedClassesPageClass][selectedClassesPageDivision][
          semesterName + "#edited#" + oldSemesterNameTemp
        ] = tempSemesterValue;
      }
    } else {
      tempClassList[selectedClassesPageClass][selectedClassesPageDivision][
        semesterName +
          "#edited#" +
          Object.keys(
            classList[selectedClassesPageClass][selectedClassesPageDivision]
          )[semesterIndex]
      ] = tempSemesterValue;
    }

    delete tempClassList[selectedClassesPageClass][selectedClassesPageDivision][
      Object.keys(
        classList[selectedClassesPageClass][selectedClassesPageDivision]
      )[semesterIndex]
    ];
    setSelectedClassesPageSemesterIndex(
      Object.keys(
        tempClassList[selectedClassesPageClass][selectedClassesPageDivision]
      ).length - 1
    );
    setClassList(tempClassList);
    setRandom(makeid(5));
  }

  function addNewSubject() {
    var tempClassList = classList;
    tempClassList[selectedClassesPageClass][selectedClassesPageDivision][
      selectedClassesPageSemester
    ].push({
      "New Subject": {
        compulsary: false,
        teacher: { user_id: "" },
      },
    });
    setClassList(tempClassList);
    setRandom(makeid(5));
  }

  function addNewClass() {
    var tempClassList = classList;
    tempClassList["New Class"] = {
      "New Division": {
        "New Semester": [
          { "New Subject": { compulsary: false, teacher: { user_id: "" } } },
        ],
      },
    };
    setClassList(tempClassList);
    setRandom(makeid(5));
  }

  function addNewDivision() {
    var tempClassList = classList;
    tempClassList[selectedClassesPageClass] = {
      "New Division": {
        "New Semester": [
          { "New Subject": { compulsary: false, teacher: { user_id: "" } } },
        ],
      },
    };
    setClassList(tempClassList);
    setRandom(makeid(5));
  }

  function addNewSemester() {
    var tempClassList = classList;
    tempClassList[selectedClassesPageClass][selectedClassesPageDivision][
      "New Semester"
    ] = [{ "New Subject": { compulsary: false, teacher: { user_id: "" } } }];
    setClassList(tempClassList);
    setRandom(makeid(5));
  }

  function updateClassList() {
    setIsSubmitting(true);
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };

    var body = {};

    var classListTemp = classList;

    for (var i = 0; i < Object.keys(classListTemp).length; i++) {
      if (Object.keys(classListTemp)[i].includes("#edited#")) {
        var newyearname = Object.keys(classListTemp)[i].split("#edited#")[0];
        var newyear = classListTemp[Object.keys(classListTemp)[i]];
        delete classListTemp[Object.keys(classListTemp)[i]];
        classListTemp[newyearname] = newyear;
      }

      for (
        var j = 0;
        j < Object.keys(classListTemp[Object.keys(classListTemp)[i]]).length;
        j++
      ) {
        if (
          Object.keys(classListTemp[Object.keys(classListTemp)[i]])[j].includes(
            "#edited#"
          )
        ) {
          var newdivi =
            classListTemp[Object.keys(classListTemp)[i]][
              Object.keys(classListTemp[Object.keys(classListTemp)[i]])[j]
            ];
          var newdiviname = Object.keys(
            classListTemp[Object.keys(classListTemp)[i]]
          )[j].split("#edited#")[0];

          delete classListTemp[Object.keys(classListTemp)[i]][
            Object.keys(classListTemp[Object.keys(classListTemp)[i]])[j]
          ];
          classListTemp[Object.keys(classListTemp)[i]][newdiviname] = newdivi;
        }
        for (
          var k = 0;
          k <
          Object.keys(
            classListTemp[Object.keys(classListTemp)[i]][
              Object.keys(classListTemp[Object.keys(classListTemp)[i]])[j]
            ]
          ).length;
          k++
        ) {
          if (
            Object.keys(
              classListTemp[Object.keys(classListTemp)[i]][
                Object.keys(classListTemp[Object.keys(classListTemp)[i]])[j]
              ]
            )[k].includes("#edited#")
          ) {
            var newsem =
              classListTemp[Object.keys(classListTemp)[i]][
                Object.keys(classListTemp[Object.keys(classListTemp)[i]])[j]
              ][
                Object.keys(
                  classListTemp[Object.keys(classListTemp)[i]][
                    Object.keys(classListTemp[Object.keys(classListTemp)[i]])[j]
                  ]
                )[k]
              ];
            var newsemname = Object.keys(
              classListTemp[Object.keys(classListTemp)[i]][
                Object.keys(classListTemp[Object.keys(classListTemp)[i]])[j]
              ]
            )[k].split("#edited#")[0];

            delete classListTemp[Object.keys(classListTemp)[i]][
              Object.keys(classListTemp[Object.keys(classListTemp)[i]])[j]
            ][
              Object.keys(
                classListTemp[Object.keys(classListTemp)[i]][
                  Object.keys(classListTemp[Object.keys(classListTemp)[i]])[j]
                ]
              )[k]
            ];
            classListTemp[Object.keys(classListTemp)[i]][
              Object.keys(classListTemp[Object.keys(classListTemp)[i]])[j]
            ][newsemname] = newsem;
          }
        }
      }
    }

    body["institution_id"] = state.auth.user.institution_id;
    body["class_list"] = classListTemp;

    axios.post(API_URL + "/update_class_list", body, config).then((res) => {
      createAlert("SUCCESS", "Success.", "Class settings saved.");
      getData();
      setIsSubmitting(false);
      setOpen2(false);
    });
  }

  function deleteClass(classIndex) {
    var tempClassList = classList;
    delete tempClassList[Object.keys(tempClassList)[classIndex]];

    setClassList(tempClassList);
    setRandom(makeid(5));
  }

  function deleteDivision(divisionIndex) {
    var tempClassList = classList;

    delete tempClassList[selectedClassesPageClass][
      Object.keys(tempClassList[selectedClassesPageClass])[divisionIndex]
    ];

    setClassList(tempClassList);
    setRandom(makeid(5));
  }

  function deleteSemester(semesterIndex) {
    var tempClassList = classList;

    delete tempClassList[selectedClassesPageClass][selectedClassesPageDivision][
      Object.keys(
        tempClassList[selectedClassesPageClass][selectedClassesPageDivision]
      )[semesterIndex]
    ];

    setClassList(tempClassList);
    setRandom(makeid(5));
  }

  function deleteSubject(subjectIndex) {
    var tempClassList = classList;

    tempClassList[selectedClassesPageClass][selectedClassesPageDivision][
      selectedClassesPageSemester
    ].splice(subjectIndex, 1);

    setClassList(tempClassList);
    setRandom(makeid(5));
  }

  function handleSubjectNameChange(subjectName, subjectIndex) {
    var tempClassList = classList;
    var tempSubjectValue =
      Object.keys(
        tempClassList[selectedClassesPageClass][selectedClassesPageDivision][
          selectedClassesPageSemester
        ][subjectIndex]
      )[0] == "edit"
        ? Object.values(
            tempClassList[selectedClassesPageClass][
              selectedClassesPageDivision
            ][selectedClassesPageSemester][subjectIndex]
          )[1]
        : Object.values(
            tempClassList[selectedClassesPageClass][
              selectedClassesPageDivision
            ][selectedClassesPageSemester][subjectIndex]
          )[0];

    var tempSubject =
      Object.keys(
        tempClassList[selectedClassesPageClass][selectedClassesPageDivision][
          selectedClassesPageSemester
        ][subjectIndex]
      )[0] == "edit"
        ? Object.keys(
            tempClassList[selectedClassesPageClass][
              selectedClassesPageDivision
            ][selectedClassesPageSemester][subjectIndex]
          )[1]
        : Object.keys(
            tempClassList[selectedClassesPageClass][
              selectedClassesPageDivision
            ][selectedClassesPageSemester][subjectIndex]
          )[0];

    delete tempClassList[selectedClassesPageClass][selectedClassesPageDivision][
      selectedClassesPageSemester
    ][subjectIndex][tempSubject];

    tempClassList[selectedClassesPageClass][selectedClassesPageDivision][
      selectedClassesPageSemester
    ][subjectIndex][subjectName] = tempSubjectValue;

    setClassList(tempClassList);
    setRandom(makeid(5));
  }

  function handleCompulsaryChange(checked, subjectIndex) {
    var tempClassList = classList;
    var tempSubject =
      tempClassList[selectedClassesPageClass][selectedClassesPageDivision][
        selectedClassesPageSemester
      ][subjectIndex];

    console.log(tempSubject);

    if (Object.keys(tempSubject)[0] == "edit") {
      tempSubject[Object.keys(tempSubject)[1]]["compulsary"] = checked;
    } else {
      tempSubject[Object.keys(tempSubject)[0]]["compulsary"] = checked;
    }
    tempClassList[selectedClassesPageClass][selectedClassesPageDivision][
      selectedClassesPageSemester
    ][subjectIndex] = tempSubject;

    setClassList(tempClassList);
    setRandom(makeid(5));
  }

  function handleTeacherChange(teacherUserID, subjectIndex) {
    var tempClassList = classList;
    var tempSubject =
      tempClassList[selectedClassesPageClass][selectedClassesPageDivision][
        selectedClassesPageSemester
      ][subjectIndex];

    for (var i = 0; i < teacherList.length; i++) {
      if (teacherList[i]["user_id"] == teacherUserID) {
        if (Object.keys(tempSubject)[0] == "edit") {
          tempSubject[Object.keys(tempSubject)[1]]["teacher"] = teacherList[i];
        } else {
          tempSubject[Object.keys(tempSubject)[0]]["teacher"] = teacherList[i];
        }
        break;
      }
    }

    tempClassList[selectedClassesPageClass][selectedClassesPageDivision][
      selectedClassesPageSemester
    ][subjectIndex] = tempSubject;

    setClassList(classList);
    setRandom(makeid(5));
  }

  function getTeacherList() {
    var teachers = teacherList.map((teacher, index) => (
      <MenuItem value={teacher["user_id"]}>{teacher["full_name"]}</MenuItem>
    ));
    return teachers;
  }

  function getClassList() {
    var classes = Object.keys(classList).map((classs, index) => (
      <MenuItem value={classs}>{classs}</MenuItem>
    ));
    return classes;
  }

  function getDivisionList() {
    var classes = Object.keys(classList[classs]).map((division, index) => (
      <MenuItem value={division}>{division}</MenuItem>
    ));
    return classes;
  }

  function getSemesterList() {
    var semesters = Object.keys(classList[classs2][division]).map(
      (semester, index) => <MenuItem value={semester}>{semester}</MenuItem>
    );
    return semesters;
  }

  function getData() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };

    body["institution_id"] = state.auth.user.institution_id;
    body = JSON.stringify(body);

    axios
      .post(API_URL + "/principal_settings_page_info", body, config)
      .then((res) => {
        setInfo(res.data);
        axios.post(API_URL + "/get_teachers_list", body, config).then((res) => {
          setTeacherList(res.data);
          axios.post(API_URL + "/get_class_list", body, config).then((res) => {
            var classListTemp = res.data;
            setClassList(classListTemp);
            setClassListOld(classListTemp);
            setClass(Object.keys(classListTemp)[0]);
            setSemester(
              Object.keys(
                classListTemp[Object.keys(classListTemp)[0]][
                  Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0]
                ]
              )[0]
            );
            setSelectedClassesPageSemester(
              Object.keys(
                classListTemp[Object.keys(classListTemp)[0]][
                  Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0]
                ]
              )[0]
            );
            setSelectedClassesPageClass(Object.keys(classListTemp)[0]);
            setDivision(
              Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0]
            );
            setClass2(Object.keys(classListTemp)[0]);
            setDivision2(
              Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0]
            );

            setIsLoading(false);
            console.log(classListTemp);
          });
        });
      });
  }

  function getContent() {
    if (selectedClassesPage == "CLASSES") {
      return (
        <Fragment>
          <Modal
            open={open3}
            onClose={() => setOpen3(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={open3}>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  backgroundColor: "white",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 400,
                  padding: "20px",
                  borderRadius: "25px",
                }}
              >
                {fileData()}
              </div>
            </Fade>
          </Modal>
          <Grid container spacing={1}>
            {Object.keys(classList).map((classListClass, classIndex) => (
              <Grid item md={3}>
                {classIndex == selectedClassesPageClassIndex ? (
                  <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={true}
                    onClose={() => setOpen(false)}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                      timeout: 500,
                    }}
                  >
                    <Fade in={true}>
                      <div
                        style={{
                          borderRadius: "15px",
                          position: "absolute",
                          top: "50%",
                          backgroundColor: "white",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          width: 400,
                          padding: "20px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                          }}
                        >
                          <TextField
                            InputProps={{
                              textAlign: "center",
                              disableUnderline: true,
                              style: {
                                color: themeStyle.primaryColor,
                                textAlign: "center",
                              },
                            }}
                            value={tempText.split("#edited#")[0]}
                            fullWidth
                            size="small"
                            onChange={(e) => setTempText(e.target.value)}
                            placeholder={"Name"}
                            variant="outlined"
                          />

                          <CardActionArea
                            style={{
                              borderRadius: "20px",
                              width: "30px",
                              height: "30px",
                              marginLeft: "10px",
                              marginTop: "5px",
                            }}
                            onClick={() => {
                              saveClassName(classListClass, classIndex);
                              setSelectedClassesPageClassIndex(9999);
                            }}
                          >
                            <CheckIcon
                              style={{ color: themeStyle.primaryColor }}
                            />
                          </CardActionArea>
                        </div>
                      </div>
                    </Fade>
                  </Modal>
                ) : (
                  <Card
                    style={{
                      borderRadius: "15px",
                      minHeight: "100%",
                      backgroundColor: "white",
                      boxShadow: "none",
                      padding: "8px 0px 10px 12px",
                    }}
                  >
                    <CardActionArea
                      sx={[
                        {
                          borderRadius: "6px",
                          border: "1.5px solid " + themeStyle.primaryColorLight,
                          transition:
                            "background-color 0.5s, border-color 0.5s",
                          backgroundColor: themeStyle.secondaryColor,
                          height: "100px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                          width: "100%",
                        },
                        (theme) => ({
                          "&:hover": {
                            backgroundColor: themeStyle.primaryColor,
                            borderColor: themeStyle.primaryColor,
                          },
                          ".MuiCardActionArea-focusHighlight": {
                            background: "transparent",
                          },

                          "&& .MuiTouchRipple-child": {
                            backgroundColor: "#084594",
                          },
                        }),
                      ]}
                      style={{
                        padding: "10px",
                      }}
                      onClick={(e) => {
                        setSelectedClassesPageClass(classListClass);
                        setSelectedClassesPageClassIndex(9999);
                        setSelectedClassesPage("DIVISIONS");
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            color: "white",
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            marginBottom: "5px",
                          }}
                        >
                          <div style={{ fontSize: "22px" }}>
                            {classListClass.split("#edited#")[0]}
                          </div>

                          <SchoolIcon style={{ fontSize: "38px" }} />
                        </div>
                        <hr style={{ opacity: "0.5" }} />
                        <div
                          style={{
                            color: "white",
                            display: "flex",
                            justifyContent: "flex-end",
                            width: "100%",
                            // marginTop: "15px",
                          }}
                        >
                          <div style={{ fontSize: "18px", color: "#ccc" }}>
                            Sections{" "}
                            {Object.keys(classList[classListClass]).toString()}
                          </div>
                        </div>
                      </div>
                    </CardActionArea>
                    {!state.auth.finalized ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginTop: "15px",
                        }}
                      >
                        <CardActionArea
                          sx={{
                            "&:hover": {
                              backgroundColor: "#f1f8ff",
                              transition: "background-color 0.5s",
                            },
                          }}
                          style={{
                            borderRadius: "20px",
                            width: "30px",
                            height: "30px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                          onClick={() => {
                            setTempText(classListClass);
                            setSelectedClassesPageClassIndex(classIndex);
                          }}
                        >
                          <EditIcon
                            style={{ color: themeStyle.primaryColor }}
                          />
                        </CardActionArea>

                        <CardActionArea
                          sx={{
                            "&:hover": {
                              backgroundColor: "#f1f8ff",
                              transition: "background-color 0.5s",
                            },
                          }}
                          style={{
                            borderRadius: "20px",
                            width: "30px",
                            height: "30px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                          onClick={() => {
                            deleteClass(classIndex);
                          }}
                        >
                          <DeleteIcon style={{ color: "#ff3333" }} />
                        </CardActionArea>
                      </div>
                    ) : (
                      ""
                    )}
                  </Card>
                )}
              </Grid>
            ))}
          </Grid>
          {state.auth.finalized ? (
            ""
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
              }}
            >
              <Button
                style={{
                  backgroundColor: themeStyle.primaryColor,
                  borderRadius: 5,
                  justifyContent: "flex-start",
                  height: "35px",
                  width: "200px",
                }}
                fullWidth
                onClick={() => addNewClass()}
              >
                <AddIcon
                  name="add"
                  style={{ color: "white", fontSize: "30px" }}
                />
                <span
                  style={{
                    textAlign: "center",
                    color: "white",
                    marginTop: "1px",
                    marginLeft: "24px",

                    fontSize: "16px",
                  }}
                >
                  ADD CLASS
                </span>
              </Button>
            </div>
          )}
        </Fragment>
      );
    } else if (selectedClassesPage == "DIVISIONS") {
      return (
        <Fragment>
          <div style={{ display: "flex", marginBottom: "15px" }}>
            <Button
              fullWidth
              style={{
                backgroundColor: themeStyle.primaryColor,
                color: "white",
                width: "5%",
                height: "35px",
                borderTopLeftRadius: "6px",
                borderBottomLeftRadius: "6px",
                borderTopRightRadius: "0px",
                borderBottomRightRadius: "0px",
              }}
              onClick={() => setSelectedClassesPage("CLASSES")}
            >
              <ArrowBackIcon style={{ fontSize: "25px" }} />
            </Button>
            <div
              textAlign="center"
              style={{
                color: themeStyle.secondaryColor,
                backgroundColor: themeStyle.primaryColorLight,
                width: "95%",
                height: "35px",
                padding: "3px 0px 0px 25px",
                alignItems: "center",
                borderTopLeftRadius: "0px",
                borderBottomLeftRadius: "0px",
                borderTopRightRadius: "6px",
                borderBottomRightRadius: "6px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  marginLeft: "-10px",
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <h2 style={{ fontSize: "20px" }}>
                  {selectedClassesPageClass.split("#edited#")[0]} Divisions
                </h2>
              </div>
            </div>
          </div>
          <Modal
            open={open3}
            onClose={() => setOpen3(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={open3}>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  backgroundColor: "white",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 400,
                  padding: "20px",
                  borderRadius: "25px",
                }}
              >
                {fileData()}
              </div>
            </Fade>
          </Modal>

          <Grid container spacing={2}>
            {Object.keys(classList[selectedClassesPageClass]).map(
              (classListDivision, divisionIndex) => (
                <Grid item md={3}>
                  {divisionIndex == selectedClassesPageDivisionIndex ? (
                    <Modal
                      aria-labelledby="transition-modal-title"
                      aria-describedby="transition-modal-description"
                      open={true}
                      onClose={() => setOpen(false)}
                      closeAfterTransition
                      BackdropComponent={Backdrop}
                      BackdropProps={{
                        timeout: 500,
                      }}
                    >
                      <Fade in={true}>
                        <div
                          style={{
                            borderRadius: "15px",
                            position: "absolute",
                            top: "50%",
                            backgroundColor: "white",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: 400,
                            padding: "20px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                            }}
                          >
                            <TextField
                              InputProps={{
                                textAlign: "center",
                                disableUnderline: true,
                                style: {
                                  color: themeStyle.primaryColor,
                                  textAlign: "center",
                                },
                              }}
                              value={tempText.split("#edited#")[0]}
                              fullWidth
                              size="small"
                              onChange={(e) => setTempText(e.target.value)}
                              placeholder={"Name"}
                              variant="outlined"
                            />

                            <CardActionArea
                              style={{
                                borderRadius: "20px",
                                width: "30px",
                                height: "30px",
                                marginLeft: "20px",
                                marginTop: "5px",
                              }}
                              onClick={() => {
                                saveDivisionName(
                                  classListDivision,
                                  divisionIndex
                                );
                                setSelectedClassesPageDivisionIndex(9999);
                              }}
                            >
                              <CheckIcon
                                style={{ color: themeStyle.primaryColor }}
                              />
                            </CardActionArea>
                          </div>
                        </div>
                      </Fade>
                    </Modal>
                  ) : (
                    <Card
                      style={{
                        borderRadius: "15px",
                        minHeight: "100%",
                        backgroundColor: "white",
                        boxShadow: "none",
                        padding: "8px 12px 10px 12px",
                      }}
                    >
                      <CardActionArea
                        sx={[
                          {
                            borderRadius: "6px",
                            border:
                              "1.5px solid " + themeStyle.primaryColorLight,
                            transition:
                              "background-color 0.5s, border-color 0.5s",
                            backgroundColor: themeStyle.secondaryColor,
                            height: "100px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                            width: "100%",
                          },
                          (theme) => ({
                            "&:hover": {
                              backgroundColor: themeStyle.primaryColor,
                              borderColor: themeStyle.primaryColor,
                            },
                            ".MuiCardActionArea-focusHighlight": {
                              background: "transparent",
                            },

                            "&& .MuiTouchRipple-child": {
                              backgroundColor: "#084594",
                            },
                          }),
                        ]}
                        style={{
                          padding: "10px",
                        }}
                        onClick={(e) => {
                          setSelectedClassesPageDivision(classListDivision);
                          setSelectedClassesPageDivisionIndex(9999);
                          if (state.auth.classType == "SEMESTERS") {
                            setSelectedClassesPage("SEMESTERS");
                          } else {
                            setSelectedClassesPage("SUBJECTS");
                          }
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              color: "white",
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                              marginBottom: "5px",
                            }}
                          >
                            <div style={{ fontSize: "22px" }}>
                              {classListDivision.split("#edited#")[0]}
                            </div>

                            <SchoolIcon style={{ fontSize: "38px" }} />
                          </div>
                          <hr style={{ opacity: "0.5" }} />
                          <div
                            style={{
                              color: "white",
                              display: "flex",
                              justifyContent: "flex-end",
                              width: "100%",
                              // marginTop: "15px",
                            }}
                          >
                            <div style={{ fontSize: "18px", color: "#ccc" }}>
                              {state.auth.classType == "SEMESTERS"
                                ? Object.keys(
                                    classList[selectedClassesPageClass][
                                      classListDivision
                                    ]
                                  ).length.toString()
                                : Object.keys(
                                    classList[selectedClassesPageClass][
                                      classListDivision
                                    ]["Term"]
                                  ).length.toString()}

                              {state.auth.classType == "SEMESTERS"
                                ? " Semesters"
                                : " Subjects"}
                            </div>
                          </div>
                        </div>
                      </CardActionArea>
                      {!state.auth.finalized ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: "15px",
                          }}
                        >
                          <CardActionArea
                            style={{
                              borderRadius: "20px",
                              width: "30px",
                              height: "30px",
                            }}
                            onClick={() => {
                              setTempText(classListDivision);
                              setSelectedClassesPageDivisionIndex(
                                divisionIndex
                              );
                            }}
                          >
                            <EditIcon
                              style={{ color: themeStyle.primaryColor }}
                            />
                          </CardActionArea>

                          <CardActionArea
                            style={{
                              borderRadius: "20px",
                              width: "30px",
                              height: "30px",
                            }}
                            onClick={() => {
                              deleteDivision(divisionIndex);
                            }}
                          >
                            <DeleteIcon style={{ color: "#ff3333" }} />
                          </CardActionArea>
                        </div>
                      ) : (
                        ""
                      )}
                    </Card>
                  )}
                </Grid>
              )
            )}
          </Grid>
          {state.auth.finalized ? (
            ""
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
              }}
            >
              <Button
                style={{
                  backgroundColor: themeStyle.primaryColor,
                  borderRadius: 5,
                  justifyContent: "flex-start",
                  height: "35px",
                  width: "200px",
                }}
                fullWidth
                onClick={() => addNewDivision()}
              >
                <AddIcon
                  name="add"
                  style={{ color: "white", fontSize: "30px" }}
                />
                <span
                  style={{
                    textAlign: "center",
                    color: "white",
                    marginTop: "1px",
                    marginLeft: "20px",

                    fontSize: "16px",
                  }}
                >
                  ADD DIVISION
                </span>
              </Button>
            </div>
          )}
        </Fragment>
      );
    } else if (selectedClassesPage == "SEMESTERS") {
      return (
        <Fragment>
          <div style={{ display: "flex", marginBottom: "15px" }}>
            <Button
              fullWidth
              style={{
                backgroundColor: themeStyle.primaryColor,
                color: "white",
                width: "5%",
                height: "35px",
                borderTopLeftRadius: "6px",
                borderBottomLeftRadius: "6px",
                borderTopRightRadius: "0px",
                borderBottomRightRadius: "0px",
              }}
              onClick={() => setSelectedClassesPage("DIVISIONS")}
            >
              <ArrowBackIcon style={{ fontSize: "25px" }} />
            </Button>
            <div
              textAlign="center"
              style={{
                color: themeStyle.secondaryColor,
                backgroundColor: themeStyle.primaryColorLight,
                width: "95%",
                height: "35px",
                padding: "3px 0px 0px 25px",
                alignItems: "center",
                borderTopLeftRadius: "0px",
                borderBottomLeftRadius: "0px",
                borderTopRightRadius: "6px",
                borderBottomRightRadius: "6px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  marginLeft: "-10px",
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <h2 style={{ fontSize: "20px" }}>
                  {selectedClassesPageClass.split("#edited#")[0] +
                    " - " +
                    selectedClassesPageDivision.split("#edited#")[0] +
                    " - "}
                  Semesters
                </h2>
              </div>
            </div>
          </div>
          <Modal
            open={open3}
            onClose={() => setOpen3(false)}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
          >
            <Fade in={open3}>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  backgroundColor: "white",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 400,
                  padding: "20px",
                  borderRadius: "25px",
                }}
              >
                {fileData()}
              </div>
            </Fade>
          </Modal>
          <Grid container spacing={2}>
            {Object.keys(
              classList[selectedClassesPageClass][selectedClassesPageDivision]
            ).map((classListSemester, semesterIndex) => (
              <Grid item md={3}>
                {semesterIndex == selectedClassesPageSemesterIndex ? (
                  <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={true}
                    onClose={() => setOpen(false)}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                      timeout: 500,
                    }}
                  >
                    <Fade in={true}>
                      <div
                        style={{
                          borderRadius: "15px",
                          position: "absolute",
                          top: "50%",
                          backgroundColor: "white",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          width: 400,
                          padding: "20px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                          }}
                        >
                          <TextField
                            InputProps={{
                              textAlign: "center",
                              disableUnderline: true,
                              style: {
                                color: themeStyle.primaryColor,
                                textAlign: "center",
                              },
                            }}
                            value={tempText.split("#edited#")[0]}
                            fullWidth
                            size="small"
                            onChange={(e) => setTempText(e.target.value)}
                            placeholder={"Name"}
                            variant="outlined"
                          />

                          <CardActionArea
                            style={{
                              borderRadius: "20px",
                              width: "30px",
                              height: "30px",
                              marginLeft: "20px",
                              marginTop: "5px",
                            }}
                            onClick={() => {
                              saveSemesterName(
                                classListSemester,
                                semesterIndex
                              );
                              setSelectedClassesPageSemesterIndex(9999);
                            }}
                          >
                            <CheckIcon
                              style={{ color: themeStyle.primaryColor }}
                            />
                          </CardActionArea>
                        </div>
                      </div>
                    </Fade>
                  </Modal>
                ) : (
                  <Card
                    style={{
                      borderRadius: "15px",
                      minHeight: "100%",
                      backgroundColor: "white",
                      boxShadow: "none",
                      padding: "8px 12px 10px 12px",
                    }}
                  >
                    <CardActionArea
                      sx={[
                        {
                          borderRadius: "6px",
                          border: "1.5px solid " + themeStyle.primaryColorLight,
                          transition:
                            "background-color 0.5s, border-color 0.5s",
                          backgroundColor: themeStyle.secondaryColor,
                          height: "100px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                          width: "100%",
                        },
                        (theme) => ({
                          "&:hover": {
                            backgroundColor: themeStyle.primaryColor,
                            borderColor: themeStyle.primaryColor,
                          },
                          ".MuiCardActionArea-focusHighlight": {
                            background: "transparent",
                          },

                          "&& .MuiTouchRipple-child": {
                            backgroundColor: "#084594",
                          },
                        }),
                      ]}
                      style={{
                        padding: "10px",
                      }}
                      onClick={(e) => {
                        setSelectedClassesPageSemester(classListSemester);
                        setSelectedClassesPageSemesterIndex(9999);
                        setSelectedClassesPage("SUBJECTS");
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            color: "white",
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            marginBottom: "5px",
                          }}
                        >
                          <div style={{ fontSize: "22px" }}>
                            {classListSemester.split("#edited#")[0]}
                          </div>

                          <SchoolIcon style={{ fontSize: "38px" }} />
                        </div>
                        <hr style={{ opacity: "0.5" }} />
                        <div
                          style={{
                            color: "white",
                            display: "flex",
                            justifyContent: "flex-end",
                            width: "100%",
                            // marginTop: "15px",
                          }}
                        >
                          <div style={{ fontSize: "18px", color: "#ccc" }}>
                            {
                              classList[selectedClassesPageClass][
                                selectedClassesPageDivision
                              ][classListSemester.split("#edited#")[0]].length
                            }{" "}
                            Subjects{" "}
                          </div>
                        </div>
                      </div>
                    </CardActionArea>
                    {!state.auth.finalized ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginTop: "15px",
                        }}
                      >
                        <CardActionArea
                          sx={{
                            "&:hover": {
                              backgroundColor: "#f1f8ff",
                              transition: "background-color 0.5s",
                            },
                          }}
                          style={{
                            borderRadius: "20px",
                            width: "30px",
                            height: "30px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                          onClick={() => {
                            setTempText(classListSemester);
                            setSelectedClassesPageSemesterIndex(semesterIndex);
                          }}
                        >
                          <EditIcon
                            style={{ color: themeStyle.primaryColor }}
                          />
                        </CardActionArea>

                        <CardActionArea
                          sx={{
                            "&:hover": {
                              backgroundColor: "#f1f8ff",
                              transition: "background-color 0.5s",
                            },
                          }}
                          style={{
                            borderRadius: "20px",
                            width: "30px",
                            height: "30px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                          onClick={() => {
                            deleteSemester(semesterIndex);
                          }}
                        >
                          <DeleteIcon style={{ color: "#ff3333" }} />
                        </CardActionArea>
                      </div>
                    ) : (
                      ""
                    )}
                  </Card>
                )}
              </Grid>
            ))}
          </Grid>
          {state.auth.finalized ? (
            ""
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
              }}
            >
              <Button
                style={{
                  backgroundColor: themeStyle.primaryColor,
                  borderRadius: 5,
                  justifyContent: "flex-start",
                  height: "35px",
                  width: "200px",
                }}
                fullWidth
                onClick={() => addNewSemester()}
              >
                <AddIcon
                  name="add"
                  style={{ color: "white", fontSize: "30px" }}
                />
                <span
                  style={{
                    textAlign: "center",
                    color: "white",
                    marginTop: "1px",
                    marginLeft: "15px",

                    fontSize: "16px",
                  }}
                >
                  ADD SEMESTER
                </span>
              </Button>
            </div>
          )}
        </Fragment>
      );
    } else if (selectedClassesPage == "SUBJECTS") {
      return (
        <Fragment>
          <div style={{ display: "flex", marginBottom: "15px" }}>
            <Button
              fullWidth
              style={{
                backgroundColor: themeStyle.primaryColor,
                color: "white",
                width: "5%",
                height: "35px",
                borderTopLeftRadius: "6px",
                borderBottomLeftRadius: "6px",
                borderTopRightRadius: "0px",
                borderBottomRightRadius: "0px",
              }}
              onClick={() =>
                state.auth.classType == "SEMESTERS"
                  ? setSelectedClassesPage("SEMESTERS")
                  : setSelectedClassesPage("DIVISIONS")
              }
            >
              <ArrowBackIcon style={{ fontSize: "25px" }} />
            </Button>
            <div
              textAlign="center"
              style={{
                color: themeStyle.secondaryColor,
                backgroundColor: themeStyle.primaryColorLight,
                width: "95%",
                height: "35px",
                padding: "3px 0px 0px 25px",
                alignItems: "center",
                borderTopLeftRadius: "0px",
                borderBottomLeftRadius: "0px",
                borderTopRightRadius: "6px",
                borderBottomRightRadius: "6px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  marginLeft: "-10px",
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <h2 style={{ fontSize: "20px" }}>
                  {state.auth.classType == "STANDARDS"
                    ? selectedClassesPageClass.split("#edited#")[0] +
                      " - " +
                      selectedClassesPageDivision.split("#edited#")[0] +
                      " - "
                    : selectedClassesPageClass.split("#edited#")[0] +
                      " - " +
                      selectedClassesPageDivision.split("#edited#")[0] +
                      " - " +
                      selectedClassesPageSemester.split("#edited#")[0] +
                      " - "}
                  Subjects
                </h2>
              </div>
            </div>
          </div>

          <Fragment>
            {classList[selectedClassesPageClass][selectedClassesPageDivision][
              selectedClassesPageSemester
            ].map((classListSubject, subjectIndex) => (
              <Grid container spacing={3}>
                <Grid item md={4}>
                  {Object.keys(classListSubject).includes("edit") ? (
                    subjectIndex == selectedClassesSubjectIndex &&
                    classListSubject["edit"] == true ? (
                      <TextField
                        InputProps={{
                          textAlign: "center",
                          disableUnderline: true,
                          style: {
                            color: themeStyle.primaryColor,
                            textAlign: "center",
                          },
                        }}
                        value={
                          Object.keys(classListSubject)[0] == "edit"
                            ? Object.keys(classListSubject)[1]
                            : Object.keys(classListSubject)[0]
                        }
                        fullWidth
                        size="small"
                        onChange={(e) =>
                          handleSubjectNameChange(e.target.value, subjectIndex)
                        }
                        placeholder={"Name"}
                        variant="outlined"
                      />
                    ) : (
                      <div style={{ marginTop: "-20px" }}>
                        <h3>
                          {Object.keys(classListSubject)[0] == "edit"
                            ? Object.keys(classListSubject)[1]
                            : Object.keys(classListSubject)[0]}
                        </h3>
                      </div>
                    )
                  ) : subjectIndex == selectedClassesSubjectIndex ? (
                    <TextField
                      InputProps={{
                        textAlign: "center",
                        disableUnderline: true,
                        style: {
                          color: themeStyle.primaryColor,
                          textAlign: "center",
                        },
                      }}
                      value={
                        Object.keys(classListSubject)[0] == "edit"
                          ? Object.keys(classListSubject)[1]
                          : Object.keys(classListSubject)[0]
                      }
                      fullWidth
                      size="small"
                      onChange={(e) =>
                        handleSubjectNameChange(e.target.value, subjectIndex)
                      }
                      placeholder={"Name"}
                      variant="outlined"
                    />
                  ) : (
                    <div style={{ marginTop: "-20px" }}>
                      <h3>
                        {Object.keys(classListSubject)[0] == "edit"
                          ? Object.keys(classListSubject)[1]
                          : Object.keys(classListSubject)[0]}
                      </h3>
                    </div>
                  )}
                </Grid>
                <Grid item md={2}>
                  {Object.keys(classListSubject).includes("edit") ? (
                    subjectIndex == selectedClassesSubjectIndex &&
                    classListSubject["edit"] == true ? (
                      <div style={{ display: "flex" }}>
                        <div style={{ display: "flex", marginLeft: "-10px" }}>
                          <Checkbox
                            labelStyle={{ color: themeStyle.primaryColor }}
                            iconStyle={{ fill: "white" }}
                            inputStyle={{ color: themeStyle.primaryColor }}
                            style={{
                              marginBottom: "2px",
                              color: themeStyle.primaryColor,
                            }}
                            checked={
                              Object.keys(classListSubject)[0] == "edit"
                                ? classListSubject[
                                    Object.keys(classListSubject)[1]
                                  ]["compulsary"]
                                : classListSubject[
                                    Object.keys(classListSubject)[0]
                                  ]["compulsary"]
                            }
                            onChange={(e) => {
                              handleCompulsaryChange(true, subjectIndex);
                            }}
                            value={1}
                            color={themeStyle.primaryColor}
                          />
                          <div style={{ marginTop: "10px" }}>Compulsory</div>
                        </div>
                        <div style={{ width: "30px" }}></div>
                        <div style={{ display: "flex", marginLeft: "-10px" }}>
                          <Checkbox
                            labelStyle={{ color: themeStyle.primaryColor }}
                            iconStyle={{ fill: "white" }}
                            inputStyle={{ color: themeStyle.primaryColor }}
                            style={{
                              marginBottom: "2px",
                              color: themeStyle.primaryColor,
                            }}
                            checked={
                              Object.keys(classListSubject)[0] == "edit"
                                ? !classListSubject[
                                    Object.keys(classListSubject)[1]
                                  ]["compulsary"]
                                : !classListSubject[
                                    Object.keys(classListSubject)[0]
                                  ]["compulsary"]
                            }
                            onChange={(e) => {
                              handleCompulsaryChange(false, subjectIndex);
                            }}
                            value={1}
                            color={themeStyle.primaryColor}
                          />
                          <div style={{ marginTop: "10px" }}>Optional</div>
                        </div>
                      </div>
                    ) : (
                      <div>
                        {Object.keys(classListSubject)[0] == "edit"
                          ? classListSubject[Object.keys(classListSubject)[1]][
                              "compulsary"
                            ]
                            ? "Compulsory"
                            : "Optional"
                          : classListSubject[Object.keys(classListSubject)[0]][
                              "compulsary"
                            ]
                          ? "Compulsory"
                          : "Optional"}
                      </div>
                    )
                  ) : subjectIndex == selectedClassesSubjectIndex ? (
                    <div style={{ display: "flex" }}>
                      <div style={{ display: "flex", marginLeft: "-10px" }}>
                        <Checkbox
                          labelStyle={{ color: themeStyle.primaryColor }}
                          iconStyle={{ fill: "white" }}
                          inputStyle={{ color: themeStyle.primaryColor }}
                          style={{
                            marginBottom: "2px",
                            color: themeStyle.primaryColor,
                          }}
                          checked={
                            Object.keys(classListSubject)[0] == "edit"
                              ? classListSubject[
                                  Object.keys(classListSubject)[1]
                                ]["compulsary"]
                              : classListSubject[
                                  Object.keys(classListSubject)[0]
                                ]["compulsary"]
                          }
                          onChange={(e) =>
                            handleCompulsaryChange(true, subjectIndex)
                          }
                          value={1}
                          color={themeStyle.primaryColor}
                        />
                        <div style={{ marginTop: "10px" }}>Compulsory</div>
                      </div>
                      <div style={{ width: "30px" }}></div>
                      <div style={{ display: "flex", marginLeft: "-10px" }}>
                        <Checkbox
                          labelStyle={{ color: themeStyle.primaryColor }}
                          iconStyle={{ fill: "white" }}
                          inputStyle={{ color: themeStyle.primaryColor }}
                          style={{
                            marginBottom: "2px",
                            color: themeStyle.primaryColor,
                          }}
                          checked={
                            Object.keys(classListSubject)[0] == "edit"
                              ? !classListSubject[
                                  Object.keys(classListSubject)[1]
                                ]["compulsary"]
                              : !classListSubject[
                                  Object.keys(classListSubject)[0]
                                ]["compulsary"]
                          }
                          onChange={(e) =>
                            handleCompulsaryChange(false, subjectIndex)
                          }
                          value={1}
                          color={themeStyle.primaryColor}
                        />
                        <div style={{ marginTop: "10px" }}>Optional</div>
                      </div>
                    </div>
                  ) : (
                    <div>
                      {classListSubject[Object.keys(classListSubject)[0]][
                        "compulsary"
                      ]
                        ? "Compulsory"
                        : "Optional"}
                    </div>
                  )}
                </Grid>
                <Grid item md={4}>
                  {subjectIndex == selectedClassesSubjectIndex ? (
                    <Select
                      value={
                        Object.keys(classListSubject)[0] == "edit"
                          ? classListSubject[Object.keys(classListSubject)[1]][
                              "teacher"
                            ]["user_id"]
                          : classListSubject[Object.keys(classListSubject)[0]][
                              "teacher"
                            ]["user_id"]
                      }
                      onChange={(e) =>
                        handleTeacherChange(e.target.value, subjectIndex)
                      }
                      style={{
                        marginTop: "2px",
                        height: "40px",
                        marginBottom: "5px",
                      }}
                      fullWidth
                      variant={"outlined"}
                    >
                      {getTeacherList()}
                    </Select>
                  ) : (
                    <span>
                      {Object.keys(classListSubject)[0] == "edit"
                        ? classListSubject[Object.keys(classListSubject)[1]][
                            "teacher"
                          ]["full_name"]
                        : classListSubject[Object.keys(classListSubject)[0]][
                            "teacher"
                          ]["full_name"]}
                    </span>
                  )}
                </Grid>
                <Grid md={2}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop:
                        subjectIndex == selectedClassesSubjectIndex
                          ? "28px"
                          : "20px",
                    }}
                  >
                    {subjectIndex == selectedClassesSubjectIndex ? (
                      <Button
                        onClick={() => {
                          setSelectedClassesSubjectIndex(9999);
                        }}
                        style={{ borderRadius: "20px" }}
                      >
                        <SaveIcon />
                      </Button>
                    ) : (
                      <Button
                        onClick={() => {
                          console.log(subjectIndex);
                          setSelectedClassesSubjectIndex(subjectIndex);
                        }}
                        style={{ borderRadius: "20px" }}
                      >
                        <EditIcon />
                      </Button>
                    )}

                    <Button
                      onClick={() => {
                        deleteSubject(subjectIndex);
                      }}
                      style={{ borderRadius: "20px" }}
                    >
                      <DeleteIcon style={{ color: "#ff3333" }} />
                    </Button>
                  </div>
                </Grid>
              </Grid>
            ))}
            {/* {state.auth.finalized ? (
              ""
            ) : ( */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
              }}
            >
              <Button
                style={{
                  backgroundColor: themeStyle.primaryColor,
                  borderRadius: 5,
                  justifyContent: "flex-start",
                  height: "35px",
                  width: "200px",
                }}
                fullWidth
                onClick={() => addNewSubject()}
              >
                <AddIcon
                  name="add"
                  style={{ color: "white", fontSize: "30px" }}
                />
                <span
                  style={{
                    textAlign: "center",
                    color: "white",
                    marginTop: "1px",
                    marginLeft: "18px",

                    fontSize: "16px",
                  }}
                >
                  ADD SUBJECT
                </span>
              </Button>
            </div>
            {/* )} */}
          </Fragment>
        </Fragment>
      );
    }
  }

  if (state.auth.refresh == "REFRESH_DATA") {
    getData();
    dispatch({ type: "REFRESH_DATA", payload: null });
  }

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (isLoading) {
        return (
          <Fragment>
            <Sidebar />
            <div
              style={{
                borderRadius: "15px",
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                backgroundColor: "white",
                marginTop: "46vh",
              }}
            >
              <CircularProgress />
            </div>
          </Fragment>
        );
      } else {
        return (
          <Fragment>
            <Sidebar />
            <Modal
              open={open3}
              onClose={() => setOpen3(false)}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={open3}>
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    backgroundColor: "white",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    padding: "20px",
                    borderRadius: "25px",
                  }}
                >
                  {fileData()}
                </div>
              </Fade>
            </Modal>
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={open2}
              onClose={() => setOpen2(false)}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={open2}>
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    backgroundColor: "white",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    padding: "20px",
                    borderRadius: "25px",
                  }}
                >
                  <div style={{ marginTop: "-25px" }}>
                    <div
                      style={{
                        marginTop: "20px",
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <IconButton size="small">
                        <CloseIcon
                          onClick={() => setOpen2(false)}
                          style={{ color: themeStyle.primaryColor }}
                        />
                      </IconButton>
                    </div>
                    <div
                      style={{
                        fontSize: "22px",
                        fontWeight: "bold",
                        color: themeStyle.primaryColor,
                      }}
                    >
                      Finalize this class structure?
                    </div>
                    <br />
                    <span>
                      This action cannot be reversed. It will be set till next
                      academic year. We recommend checking all classes,
                      divisions, and semesters again. All Subjects and Teachers
                      must be added before adding students.
                    </span>
                    <br></br>
                    <br></br>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        onClick={() => updateClassList()}
                        style={{
                          height: "30px",
                          backgroundColor: themeStyle.primaryColor,
                        }}
                        variant="contained"
                      >
                        Yes
                      </Button>
                      <Button
                        style={{
                          height: "30px",
                          marginLeft: "10px",
                          backgroundColor: themeStyle.primaryColor,
                        }}
                        variant="contained"
                        onClick={() => setOpen2(false)}
                      >
                        No
                      </Button>
                    </div>
                  </div>
                </div>
              </Fade>
            </Modal>
            <div
              style={{
                borderRadius: "15px",
                margin: "65px 15px 20px 85px",
                backgroundColor: "white",
              }}
            >
              {getContent()}
              {/* <Button
                fullWidth
                onClick={() => setOpen2(true)}
                p={2}
                style={{
                  position: "fixed",
                  bottom: 30,
                  right: 30,
                  backgroundColor: themeStyle.primaryColor,
                  color: "white",
                  height: "30px",
                  width: "200px",
                }}
                borderRadius={6}
              >
                <h3
                  style={{
                    marginTop: "17px",
                    fontSize: "15px",
                  }}
                >
                  {state.auth.finalized ? "UPDATE CLASSES" : "FINALIZE CLASSES"}
                </h3>
              </Button> */}
              <Drawer
                anchor={"right"}
                open={toggleDrawer}
                onClose={() => setToggleDrawer(false)}
              >
                <div
                  style={{
                    width: "25vw",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    marginTop: "-60px",
                    padding: "25px",
                  }}
                >
                  <img
                    style={{
                      maxHeight: "128px",
                      margin: "100px 0px 25px 0px",
                    }}
                    src={require("../../img/xl.png")}
                  />
                  <Typography
                    variant="h6"
                    gutterBottom
                    style={{
                      fontFamily: "Campton Book",
                      color: themeStyle.primaryColor,
                      fontSize: "30px",
                      fontWeight: "bold",
                    }}
                  >
                    Upload Spreadsheet
                  </Typography>
                  <br />

                  <span
                    style={{
                      color: themeStyle.primaryColor,

                      fontSize: "14px",
                    }}
                  >
                    Class
                  </span>
                  <Select
                    value={classs2}
                    onChange={(e) => handleClassChange(e)}
                    style={{
                      marginTop: "2px",
                      height: "40px",
                      marginBottom: "5px",
                    }}
                    fullWidth
                    variant={"outlined"}
                  >
                    {getClassList()}
                  </Select>

                  <br />
                  {state.auth.classType == "SEMESTERS" ? (
                    <span
                      style={{
                        color: themeStyle.primaryColor,

                        fontSize: "14px",
                      }}
                    >
                      Semester
                    </span>
                  ) : (
                    ""
                  )}
                  {state.auth.classType == "SEMESTERS" ? (
                    <Select
                      value={semester}
                      onChange={(e) => handleSemesterChange(e)}
                      style={{
                        marginTop: "2px",
                        height: "40px",
                        marginBottom: "5px",
                      }}
                      fullWidth
                      variant={"outlined"}
                    >
                      {getSemesterList()}
                    </Select>
                  ) : (
                    ""
                  )}
                  <label
                    style={{
                      borderRadius: "15px",
                      padding: "20px",
                      backgroundColor: "white",
                    }}
                    htmlFor="contained-button-file"
                  >
                    <input
                      style={{ display: "none" }}
                      id="contained-button-file"
                      type="file"
                      onChange={(e) => onFileChange(e)}
                    />

                    <FileUploadCard />
                    <Button
                      style={{
                        width: "100%",
                        fontSize: "20px",
                        height: "40px",
                        marginTop: "-1px",
                        backgroundColor: themeStyle.primaryColor,
                        fontFamily: "Campton Book",
                      }}
                      variant="contained"
                      component="span"
                    >
                      Upload Latest XL File
                    </Button>
                  </label>
                  <br />
                  {isUploading ? <CircularProgress /> : ""}
                </div>
              </Drawer>
              <div
                style={{
                  height: "50px",
                  width: "175px",
                  padding: "5px 10px",
                  borderRadius: "50px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  boxShadow: "none",
                  backgroundColor: themeStyle.primaryColor,
                  position: "fixed",
                  bottom: 30,
                  right: 30,
                  cursor: "pointer",
                }}
                onClick={() => setToggleDrawer(true)}
                aria-label="add"
              >
                <PublishIcon
                  style={{
                    color: "white",
                    marginRight: "5px",
                    fontSize: "30px",
                  }}
                />
                <div
                  style={{
                    color: "white",
                    fontSize: "18px",
                    fontWeight: "bold",
                  }}
                >
                  Upload XL
                </div>
              </div>
            </div>
          </Fragment>
        );
      }
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{
          borderRadius: "15px",
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}
export default ClassesOnboarding;
